import Percent from '../src/Percent/index.tsx';
export default Percent;
